import { Map, fromJS } from 'immutable';

import Actions from 'flow/actions';
import { listToMap } from 'flow/utils';

const initialState = Map();

const profileReducer = (state = initialState, action) => {
    switch (action ? action.type : null) {
        case Actions.CLEAR_STATE:
            return initialState;
        case Actions.RESULT_PROFILES:
            return state.update(action.key, null, () => fromJS(action.data));
        case Actions.RESULT_PROFILE: {
            const profile = fromJS(action.data);

            return state.update(action.key, (prev) => {
                const index = prev.findIndex(
                    (p) => p.get('key') === profile.get('key'),
                );

                if (index !== -1) {
                    return prev.set(index, profile);
                } else {
                    return prev;
                }
            });
        }
        case Actions.RESULT_REMOVE_PROFILE:
            return state.update(action.key, (prev) => {
                return prev.filter(
                    (profile) => profile.get('key') !== action.profileKey,
                );
            });
        case Actions.RESULT_PROFILE_CREATE:
            return state.set(
                action.key,
                state.get(action.key).push(fromJS(action.data)),
            );
        case Actions.NOTIFY_NEW_PROFILE_CREATED:
            return state.set('notifyNewProfileCreated', true);
        case Actions.REMOVE_NOTIFY_NEW_PROFILE_CREATED:
            return state.delete('notifyNewProfileCreated');
        case Actions.SET_PERMISSION_ERROR:
            return state.set(action.key, true);
        case Actions.REMOVE_PERMISSION_ERROR:
            return state.set(action.key, false);
        case Actions.RESULT_REFERAL_ENTRIES:
            return state.update('referal_sounds', () => fromJS(action.data));
        case Actions.RESULT_MAIN_NUMBERS:
            return state.update('main_numbers', () => fromJS(action.data));
        case Actions.RESULT_SMSSENDER_NAMES: {
            const optionList = listToMap(fromJS(action.data), (option) =>
                option.get('key'),
            );
            return state.set('smsSenderNameOptions', optionList);
        }
        default:
            return state;
    }
};

export default profileReducer;
